import { render, staticRenderFns } from "./VerticalNavMenuItemsDynamic.vue?vue&type=template&id=9dbdb952&"
import script from "./VerticalNavMenuItemsDynamic.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItemsDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports